import { StyleProvider } from "@ant-design/cssinjs";
import { ReactNode } from "react";

export default function AntdStyleProvider({
  children,
}: {
  children: ReactNode;
}) {
  return <StyleProvider hashPriority="high">{children}</StyleProvider>;
}
